import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { ArrowRight } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-32 px-6 bg-[#0f0f0f] border-t border-white/5 text-center" data-id="element-70">
      <div className="max-w-3xl mx-auto" data-id="element-71">
        <FadeIn data-id="element-72">
          <div className="inline-block mb-8" data-id="element-73">
            <span className="text-7xl md:text-9xl font-black text-white tracking-tighter" data-id="element-74">
              $6.36
            </span>
            <span className="text-xl text-gray-500 uppercase tracking-widest block mt-2" data-id="element-75">
              Pago único
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-76">
          <p className="text-2xl md:text-3xl font-bold text-white mb-8" data-id="element-77">
            No es caro.
          </p>
          <p className="text-xl text-gray-300 mb-12 leading-relaxed" data-id="element-78">
            Lo caro es seguir pagando con tu vida:{' '}
            <br className="hidden md:block" data-id="element-79" />
            noches perdidas, culpa, estancamiento y esa sensación de{' '}
            <br className="hidden md:block" data-id="element-80" />
            <span className="italic text-white" data-id="element-81">"yo podría… pero no".</span>
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-82">
          <div className="bg-blue-900/10 border border-blue-900/30 p-6 rounded-sm mb-12 inline-block" data-id="element-83">
            <p className="text-lg md:text-xl font-medium text-blue-200" data-id="element-84">
              Si lo haces en serio, este PDF no te cambia el mood. <br data-id="element-85" />
              <strong className="text-white" data-id="element-86">Te cambia el estándar.</strong>
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-87">
          <a href="https://www.evolucionaactivo.com/cart/43882681499734:1" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto group relative inline-flex items-center justify-center px-12 py-6 text-xl font-bold text-white bg-blue-600 hover:bg-blue-700 transition-all duration-300 rounded-none tracking-wide shadow-[0_0_40px_-10px_rgba(37,99,235,0.5)] hover:shadow-[0_0_60px_-10px_rgba(37,99,235,0.7)]" data-id="element-88">
            CONSEGUIR LOCK IN AHORA - $6.36
            <ArrowRight className="ml-3 w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-89" />
          </a>
        </FadeIn>

        <FadeIn delay={0.6} className="mt-24 pt-24 border-t border-white/5" data-id="element-90">
          <p className="text-2xl font-bold text-white mb-8" data-id="element-91">
            Si ya estás cansado de prometerte y fallarte… <br data-id="element-92" />
            <span className="text-blue-500" data-id="element-93">entra al modo LOCK IN.</span>
          </p>
          <button className="text-gray-400 hover:text-white font-medium flex items-center justify-center gap-2 mx-auto transition-colors" data-id="element-94">
            EMPEZAR CON EL DÍA 1 (RESET) <ArrowRight className="w-4 h-4" data-id="element-95" />
          </button>
        </FadeIn>
      </div>
    </section>;
}